<template>
  <v-card :to="item.to" elevation="0" class="rounded-xl service-card">
    <img
      :src="parsedImg"
      :alt="item.title"
      width="100%"
      height="100%"
      class="service-img rounded-xl"
    />
    <div class="service-card-container">
      <h3 class="transition">{{ item.title }}</h3>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    },
  },
  computed: {
    parsedImg() {
      let img = "";

      if (!/^https?:\/\//.test(this.item.img)) {
        img = this.files;
      }

      img += this.item.img;

      const width = 390;

      return `${img}?resize=1&w=${width}`;
    },
  },
};
</script>

<style lang="scss">
.service-card {
  position: relative;

  img {
    filter: grayscale(1) brightness(30%);
    transition: all 0.5s;
    aspect-ratio: 3/2;
    object-fit: cover;
  }

  .service-card-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    h3 {
      font-size: 24px;
      font-weight: 700;
      color: #fff;
    }
  }
  &::after {
    content: "";
    width: 100px;
    height: 8px;
    border-radius: 8px;
    background: var(--v-primary-base);
    margin: auto;
    transition: all 0.5s;
    display: block;
    margin-top: -10px;
    z-index: 1;
    position: relative;
  }
  &:hover {
    img {
      filter: grayscale(0) brightness(80%);
    }
    &::after {
      width: 80%;
    }
  }
}
</style>
